/*
 * Passa a Shopify la scelta fatta nel banner di iubenda (bozza 1.4.2, 4 ottobre 2026).
 *
 * Perche': iubenda non comunica il consenso a Shopify, quindi per Shopify ogni visitatore resta
 * "senza scelta". Le statistiche di Shopify, la pagina d'arrivo degli ordini e i pixel delle app
 * (Google, Meta) che rispettano il consenso vedono cosi' solo una parte delle visite.
 *
 * Corrispondenza delle finalita' di iubenda:
 *   2 funzionalita', 3 esperienza  -> preferences
 *   4 misurazione                  -> analytics
 *   5 marketing                    -> marketing e sale_of_data
 * Si scrive solo quando il visitatore ha scelto, e di nuovo se cambia idea.
 */
(() => {
  const ATTESA_MASSIMA = 120000;

  function sceltaIubenda() {
    try {
      const s = window._iub && window._iub.cs && window._iub.cs.consent && window._iub.cs.consent.purposes;
      if (!s || !Object.keys(s).length) return null;
      return {
        preferences: s['2'] === true || s['3'] === true,
        analytics: s['4'] === true,
        marketing: s['5'] === true,
        sale_of_data: s['5'] === true,
      };
    } catch (e) {
      return null;
    }
  }

  let api = null;
  function caricaApi() {
    if (api) return api;
    api = new Promise((pronto) => {
      if (window.Shopify && window.Shopify.customerPrivacy) return pronto(window.Shopify.customerPrivacy);
      if (!window.Shopify || !window.Shopify.loadFeatures) return pronto(null);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (errore) =>
        pronto(errore ? null : window.Shopify.customerPrivacy)
      );
    });
    return api;
  }

  let ultima = null;
  async function controlla() {
    const scelta = sceltaIubenda();
    if (!scelta) return;
    const chiave = JSON.stringify(scelta);
    if (chiave === ultima) return;
    ultima = chiave;
    const privacy = await caricaApi();
    if (!privacy || !privacy.setTrackingConsent) return;
    privacy.setTrackingConsent(scelta, () => {});
  }

  function avvia() {
    controlla();
    const inizio = Date.now();
    const giro = setInterval(() => {
      controlla();
      if (Date.now() - inizio > ATTESA_MASSIMA) clearInterval(giro);
    }, 1000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) controlla();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
